import React from 'react'

import { DepthKeys, useLanguages } from '@/hooks'
import { INavItem, TFunc } from '@/types'

export const ItemTitle: React.FC<
  Pick<INavItem<DepthKeys>, 'title'> & { onOpen: TFunc }
> = ({ title, onOpen }) => {
  const { t } = useLanguages()
  return <h5 onClick={onOpen}>{t(title)}</h5>
}
